import React from "react";

export function WorkshopSessionDetailModalBody(props) {
    return (
        <div className="panel panelspecialsession">
            <div className="specialsession" id="aux">
                <div className="panel-body">
                    <span className="pull-right" title="Edit special session">
                        <span className="pull-right glyphicon glyphicon-edit openmodal-specialsession pointer"
                              onClick={props.handleEditSessionClick}>
                        </span>
                    </span>
                    <div className="specialsessiontype">{props.session.type}</div>
                    <div className="specialsessionchair">
                    </div>
                    <div className="specialsessiontitle">{props.session.data.name}</div>
                    <div className="specialsessionauthor">
                    </div>
                    <div className="specialsessionabstract">
                        <p style={{color: "#999", fontSize: "80%"}}>
                            The schedule is approximate. Check the workshop's website for further detail.
                        </p>

                        <p style={{marginTop: "0", fontSize: "120%", fontFamily: "serif"}}>
                            {props.session.data.short_name} - {props.session.data.name}
                        </p>


                        <p>
                            <a href={props.session.data.url}>
                                {props.session.data.url}
                            </a>
                        </p>
                        <p style={{textAlign: "right", margin: "1.5em 0"}}>
                            <a style={{fontSize: "110%", color: "white", fontWeight: "bold", background: "#33a3ed", padding: ".4em 2em .2em", fontFamily: "'Roboto', sans", borderRadius: "3px", textDecoration: "none"}}
                               href={props.session.data.url}>
                                Open website
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
